import { createReducer } from '@reduxjs/toolkit'
import {
  logoutAction,
  updateAccountActivatingAction,
  updateAccountInfo,
  updateAccountTickets,
  updateBalancesAction,
  updateUserToken,
} from './actions'
import { getAccountBalanceAction } from './actions/getAccountBalanceActions'
import { getAccountInfoAction } from './actions/getAccountInfoActions'
import { connectZkexAction } from './actions/connectZkexActions'
import { AccountState } from './types'
import { isEqual } from 'lodash'

const initialState: AccountState = {
  connecting: false,
  accountInfo: null,
  // When the user clicks the activation button until the signing process in the web3 is completed, this value should be 'true.'
  // The activation status of 'accountInfo.status' is not stable and can be overwritten by the polling mechanism.
  activating: false,
  tickets: undefined,
  balances: [],
  token: '',
}

export default createReducer<AccountState>(initialState, (builder) => {
  builder
    .addCase(getAccountInfoAction.fulfilled, (state, { payload }) => {
      state.accountInfo = payload
    })
    .addCase(updateAccountInfo, (state, { payload }) => {
      state.accountInfo = payload
    })
    .addCase(connectZkexAction.pending, (state) => {
      state.connecting = true
    })
    .addCase(connectZkexAction.rejected, (state) => {
      state.connecting = false
    })
    .addCase(connectZkexAction.fulfilled, (state) => {
      state.connecting = false
    })
    .addCase(updateAccountActivatingAction, (state, { payload }) => {
      state.activating = payload
    })
    .addCase(getAccountBalanceAction.fulfilled, (state, { payload }) => {
      if (isEqual(state.balances, payload)) {
        console.debug('balances is equal, do not update the balances.')
      } else {
        state.balances = payload
      }
    })
    .addCase(updateBalancesAction, (state, { payload }) => {
      const index = state.balances.findIndex(
        (b) => b.currencyId === payload.currencyId,
      )
      if (index > -1) {
        state.balances[index].available = payload.available
        state.balances[index].freeze = payload.freeze
      }
    })
    .addCase(updateAccountTickets, (state, { payload }) => {
      state.tickets = payload
    })
    .addCase(updateUserToken, (state, { payload }) => {
      state.token = payload
    })
    .addCase(logoutAction, (state) => {
      state.token = ''
      state.balances = []
      state.accountInfo = null

      // clear the login ticket
      // change the account from unregister to register must clear the ticket
      state.tickets = undefined
    })
})
